import React from "react";

import {TextField, InputAdornment } from '@mui/material';
import DollarIcon from '@mui/icons-material/AttachMoney';
import CustomTextField from '../../../components/custom-text-field/custom-text-field';

import '../../hoa-styles.scss';
import '../hoa-municipality-styles.scss'

const toolbar = 64;
const titleBar = 102;
const padding = 32;
const responsiveHeight = toolbar+ titleBar+padding;

interface MunicipalityFeesFormProps {
    state: any;
    setState: any;
    checkError : boolean;
    responsiveHeight: number;
}


export default function MunicipalityFeesForm(props : MunicipalityFeesFormProps) {
    const {state, setState, checkError} = props;

    const handleChange = (value: string, key: string) => {
        let tempState : any = state;
        tempState[key] = value;
        setState({...tempState});
    }

    const Wheel =(e: any) => {
        e.target.blur();
    }
    return (
        <div style={{ justifyContent: 'center', fontSize: '20px', width: "100%", height: "100%", boxSizing: "border-box" }}>
            <div style={{ display: 'flex', flexDirection: 'column', border: "1px solid #E8E8E8", borderRadius: "4px", width: "100%" }}>

                <div style={{ height:(window.innerHeight - props.responsiveHeight) ,  overflow:'scroll' }} className = "add-municipality-form-container">
                    <div className ="left-form-container">
                        <div className="sub-title-text">Rental Registration</div>

                        <div style={{ display: "flex", marginBottom: "24px", justifyContent: "space-between" }}>
                            <TextField variant="standard" style={{ width: "45%", }} value={state.registrationFee} type = 'number' onWheel={e => Wheel(e)}
                                onChange={(e)=>{handleChange(e.target.value, "registrationFee")}} label="Registration Fee" InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{
                                    style:{ padding:"7px 0px"},
                                    endAdornment :(
                                        <InputAdornment position="end">
                                            <DollarIcon />
                                        </InputAdornment>
                            )}}/>
                            <TextField style={{ width: "45%" }} variant="standard" label="Registration Renewal Frequency" value={state.renewalFrequency}
                                onChange={(e)=>{handleChange(e.target.value, "renewalFrequency")}} InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{style:{ padding:"7px 0px"}}}/>
                            {/* <FormControl style={{ width: "50%",  }} variant="standard">
                                <InputLabel className='select-label'>Registration Renewal Frequency</InputLabel>
                                <Select
                                    label="Market"
                                    onChange={(e)=>{handleChange(e.target.value, "renewalFrequency")}}
                                    value={state.renewalFrequency} style={{padding:"7px 0px"}}
                                >
                                {
                                    config.frequencyOptions.map((option : string) => {
                                        return <MenuItem key={`key ${option}`} value={option}>{option}</MenuItem>
                                    })
                                }
                                </Select>
                            </FormControl> */}
                        </div>

                        <div style={{ display: "flex", marginBottom: "24px", justifyContent: "space-between" }}>
                            <TextField variant="standard" style={{ width: "45%", }} value={state.landLordRegistrationFee} type = 'number' onWheel={e => Wheel(e)}
                                onChange={(e)=>{handleChange(e.target.value, "landLordRegistrationFee")}} label="Landlord Registration Fee" InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{
                                    style:{ padding:"7px 0px"},
                                    endAdornment :(
                                    <InputAdornment position="end">
                                        <DollarIcon />
                                    </InputAdornment>
                            )}}/>
                            <TextField style={{ width: "45%" }} variant="standard" label="Landlord Registration Renewal Frequency" value={state.landlordRenewalFrequency}
                                onChange={(e)=>{handleChange(e.target.value, "landlordRenewalFrequency")}} InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{style:{ padding:"7px 0px"}}}/>
                            {/* <FormControl style={{ width: "50%",  }} variant="standard">
                                <InputLabel className='select-label'>Landlord Registration Renewal Frequency</InputLabel>
                                <Select
                                    label="Market"
                                    onChange={(e)=>{handleChange(e.target.value, "landlordRenewalFrequency")}}
                                    value={state.landlordRenewalFrequency} style={{padding:"7px 0px"}}
                                >
                                {
                                    config.frequencyOptions.map((option : string) => {
                                        return <MenuItem key={`key ${option}`} value={option}>{option}</MenuItem>
                                    })
                                }
                                </Select>
                            </FormControl> */}
                        </div>

                        <div style={{ display: "flex", marginBottom: "24px", justifyContent: "space-between" }}>
                            <TextField variant="standard" style={{ width: "45%", }} value={state.registrationAdminFee} type = 'number' onWheel={e => Wheel(e)}
                                onChange={(e)=>{handleChange(e.target.value, "registrationAdminFee")}} label="Registrations Admin Fee" InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{
                                    style:{ padding:"7px 0px"},
                                    endAdornment :(
                                    <InputAdornment position="end">
                                        <DollarIcon />
                                    </InputAdornment>
                            )}}/>
                            <TextField variant="standard" style={{ width: "45%", }} value={state.registrationConvenienceFee} type = 'number' onWheel={e => Wheel(e)}
                                onChange={(e)=>{handleChange(e.target.value, "registrationConvenienceFee")}} label="Registrations Convenience Fee" InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{
                                    style:{ padding:"7px 0px"},
                                    endAdornment :(
                                    <InputAdornment position="end">
                                        <DollarIcon />
                                    </InputAdornment>
                            )}}/>
                        </div>

                        <div className="sub-title-text" style={{marginTop:"48px"}}>Tax Schedule and Penalty</div>

                        <div style={{ display: "flex", marginBottom: "24px", justifyContent: "space-between" }}>
                            <TextField style={{ width: "45%" }} variant="standard" label="Residential Landlord Tax Schedule" value={state.residentialLandlordTaxSchedule}
                                onChange={(e)=>{handleChange(e.target.value, "residentialLandlordTaxSchedule")}} InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{style:{ padding:"7px 0px"}}}/>
                            {/* <FormControl style={{ width: "50%" }} variant="standard">
                                <InputLabel className='select-label'>Residential Landlord Tax Schedule</InputLabel>
                                <Select
                                    label="Market"
                                    onChange={(e) => { handleChange(e.target.value, "residentialLandlordTaxSchedule") }}
                                    value={state.residentialLandlordTaxSchedule} style={{padding:"7px 0px"}}
                                >
                                    {
                                        config.frequencyOptions.map((option: string) => {
                                            return <MenuItem key={`key ${option}`} value={option}>{option}</MenuItem>
                                        })
                                    }
                                </Select>
                            </FormControl> */}
                            <TextField variant="standard" style={{ width: "45%", }} value={state.penalty} type = 'text'
                                onChange={(e)=>{handleChange(e.target.value, "penalty")}} label="Penalty %" InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{
                                    style:{ padding:"7px 0px"}
                            }}/>
                        </div>
                    </div>

                    <div className='right-form-container'>
                        <div className="sub-title-text">Fee Amounts</div>

                        <div style={{ display: "flex", marginBottom: "24px", justifyContent: "space-between" }}>
                            <TextField variant="standard" style={{ width: "48%", }} value={state.renewalProcessingFee} type = 'number' onWheel={e => Wheel(e)}
                                onChange={(e)=>{handleChange(e.target.value, "renewalProcessingFee")}} label="Renewal Processing Fee" InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{
                                    style:{ padding:"7px 0px"},
                                    endAdornment :(
                                    <InputAdornment position="end">
                                        <DollarIcon />
                                    </InputAdornment>
                            )}}/>
                            <TextField variant="standard" style={{ width: "48%", }} value={state.applicationFee} type = 'number' onWheel={e => Wheel(e)}
                                onChange={(e)=>{handleChange(e.target.value, "applicationFee")}} label="Application Fee" InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{
                                    style:{ padding:"7px 0px"},
                                    endAdornment :(
                                    <InputAdornment position="end">
                                        <DollarIcon />
                                    </InputAdornment>
                            )}}/>
                        </div>
                        <div style={{ display: "flex", marginBottom: "24px", justifyContent: "flex-start" }}>
                            <TextField variant="standard" style={{ width: "48%", }} value={state.stateMandateFee} type = 'number' onWheel={e => Wheel(e)}
                                onChange={(e)=>{handleChange(e.target.value, "stateMandateFee")}} label="State Mandated Fee" InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{
                                    style:{ padding:"7px 0px"},
                                    endAdornment :(
                                    <InputAdornment position="end">
                                        <DollarIcon />
                                    </InputAdornment>
                            )}}/>
                        </div>
                        <div style={{ display: "flex", marginBottom: "24px", justifyContent: "flex-start" }}>
                            <CustomTextField variant="standard" style={{ width: "48%", }} value={state.renewalFee} type = 'number' onWheel={e => Wheel(e)}
                                onChange={(e)=>{handleChange(e.target.value, "renewalFee")}} label="Renewal Fee" InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{
                                    style:{ padding:"7px 0px"},
                                    endAdornment :(
                                    <InputAdornment position="end">
                                        <DollarIcon />
                                    </InputAdornment>
                            )}}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}